import Storage from '~/Services/Storage';

export default new Storage();
